/**
 * Copy for the trial disclosure shown above the sign-up form.
 *
 * Built from the plan document squidward returns, not from a SKU list: the
 * disclosure states a billing promise, so it is shown exactly when the plan is
 * a trial that takes a card, and every number in it comes from the plan.
 *
 * Kept as a pure function returning strings — no JSX — so the copy can be
 * asserted without rendering the sign-up page.
 */

/** Plan billing frequency to the noun the copy bills "per". */
const BILLING_TERMS = {
  monthly: 'month',
  yearly: 'year',
}

/**
 * @param {object} plan Plan document as stored by the sign-up provider.
 * @returns {{requirement: string, billing: string} | null} The two lines of the
 *   disclosure, or `null` when the plan warrants no disclosure at all (not a
 *   trial, or a trial that takes no card).
 */
export const buildTrialDisclosure = (plan = {}) => {
  const {
    amount,
    frequency,
    isTrial,
    requiresBilling,
    trialLength,
  } = plan ?? {}

  if (!isTrial || !requiresBilling) return null

  const term = BILLING_TERMS[frequency]

  if (!term || !trialLength || !amount) return null

  return {
    requirement: 'Credit card required, cancel anytime.',
    billing: `$${amount}/${term} billed after ${trialLength}-day trial.`,
  }
}

export default buildTrialDisclosure
